"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _router = require("@reach/router");

var _GatsbyImage = _interopRequireDefault(require("./GatsbyImage"));

var _theme = require("../theme");

var _templateObject, _templateObject2, _templateObject3;

var ListItem = function ListItem(props) {
  var _props$level = props.level,
      level = _props$level === void 0 ? 0 : _props$level,
      link = props.link,
      actions = props.actions,
      title = props.title,
      subtitle = props.subtitle,
      status = props.status,
      image = props.image,
      _props$showImage = props.showImage,
      showImage = _props$showImage === void 0 ? false : _props$showImage,
      rest = (0, _objectWithoutProperties2.default)(props, ["level", "link", "actions", "title", "subtitle", "status", "image", "showImage"]);

  var listItemTitle = /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    strong: true
  }, title, status);

  var metaTitle = link ? /*#__PURE__*/_react.default.createElement(StyledLink, {
    to: link
  }, listItemTitle) : listItemTitle;
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    level: level
  }, rest), /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement(_antd.List.Item, {
    actions: actions
  }, /*#__PURE__*/_react.default.createElement(_antd.List.Item.Meta, {
    avatar: showImage && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, image ? /*#__PURE__*/_react.default.createElement(_GatsbyImage.default, {
      image: image,
      objectFit: "cover",
      objectPosition: "50% 50%",
      alt: image.alt,
      style: {
        width: '50px',
        height: '50px'
      }
    }) : /*#__PURE__*/_react.default.createElement(ImagePlaceholder, null)),
    title: metaTitle,
    description: subtitle
  }))));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: ", ";\n\n  .ant-card-body {\n    padding: 0 20px;\n  }\n"])), function (_ref) {
  var level = _ref.level;
  return "".concat(level * 30, "px");
});

var ImagePlaceholder = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 50px;\n  height: 50px;\n  background: ", ";\n"])), _theme.colors.tertiary);

var StyledLink = (0, _styledComponents.default)(_router.Link)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    flex: 1;\n\n    &:hover {\n      .ant-typography {\n        color: ", ";\n      }\n    }\n  }\n"])), _theme.colors.primary);
var _default = ListItem;
exports.default = _default;